import React from "react";

type LiveVideoProps = {
  color?: string, // Cor personalizada para o ícone
  size?: number, // Tamanho do ícone
};

const LiveVideo: React.FC<LiveVideoProps> = ({
  color = "#FF0000",
  size = 25,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Fundo circular */}
      <circle cx="12" cy="12" r="10" fill={color} opacity="0.2" />

      {/* Onda externa */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />

      {/* Onda interna */}
      <circle
        cx="12"
        cy="12"
        r="6"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />

      {/* Botão de Play */}
      <polygon points="10,8 16,12 10,16" fill={color} />
    </svg>
  );
};

export default LiveVideo;
